<template>
  <div>
    <div class="bg-white rounded border-0 shadow-sm">
      <div class="d-flex align-items-end pt-4 pl-3 pr-3 mb-4">
        <div class="d-flex flex-column">
          <h5 class="mb-1">Input Types</h5>
          <p class="text-gray-500">Create various type inputs such as: <span class="text-danger">text, password, number, url, email, search, range, date and more.</span></p>
        </div>
        <ButtonGroup>
          <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
          <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
        </ButtonGroup>
      </div>

      <CodePreviewViewer :viewMode="view" :codeSample="require('@/components/local/Input/input_type.js').default">
        <template v-slot:preview>
          <div>
            <Input label="Text" />
            <Input type="number" label="Number"/>
            <Input type="email" label="Email" />
            <Input type="password" label="Password" />
            <Input type="search" label="Search" />
            <Input type="url" label="URL" />
            <Input type="tel" label="Tel" />
            <Input type="date" label="Date"/>
            <Input type="time" label="Time"/>
            <Input type="range" label="Range" />
            <Input type="color" label="Color" />
          </div>
        </template>
      </CodePreviewViewer>
    </div>
  </div>
</template>

<script>
import Input from '@/components/export/Input/Input'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
 components: { Input, ButtonGroup, CodePreviewViewer },
 data () {
   return {
     view: 'preview',
     viewSizing: 'preview',
     text:'',
     errors: 'Sample error message here'
   }
 }
}
</script>